const url = {
  COMMON: {
    LOGGING_VALID: '/auth-rest/loggingValid/res', // 权限校验接口 ?checkUrl=/sfs/analyze
    USER_INFO: '/portal/getUserInfo', // 用户信息
    USER_MENU: '/auth-rest/menu/getUserMenu', // 获取用户导航信息 ?userName=qinyin
    SLIDER_MENU: '/app/v1/userperm/resource', // 获取左侧菜单 ?appIds=3
    VERSIONS: '/auth-rest/edition/editions', // 获取版本号
    // 头部导航相关接口
    SELLER_LIST: '/auth-rest/eclpMasterSellers/sellerlist', // 获取商家查询信息 ?sellerName=
    DEPT: '/app/v1/perm/dept/list', // 部门/事业部接口
    // 头部导航消息相关接口
    UN_READ_COUNT: '/auth-rest/remind/message/unReadCount', // 获取租户未读取的消息数
    MSG_LIST: '/auth-rest/remind/message/messageList', // 获取用户消息数量
    READ_MSG: '/auth-rest/remind/message/readMessage', // 读取当前消息
    READ_All_MSG: '/auth-rest/remind/message/readAllMessage', // 未读消息全部标记为已读
    // 退出
    USER_LOGOUT: '/auth-rest/logout' // 退出登录
  },
  HOME: {
    NOTICE_GROUP: '/auth-rest/notice/group', // 获取公告相关信息-获取当前用户需要查看的 ids
    NOTICE_VIEW: '/auth-rest/notice/view', // 获取公告相关信息-获取公告详情
    NOTICE_HAS_VIEW: '/auth-rest/notice/hasView', // 获取公告相关信息-
    ORDERS: '/auth-rest/order/orders', // ECLP商家获取对应的订单版本情况
    USERNOTICE_GET: '/auth-rest/userNotice/get', //
    USERNOTICE_SAVE: '/auth-rest/userNotice/save', // 不再提醒
    //
    DEPT_INFO: '/portal/getDeptInfo', // 获取事业部 {userPin:用户pin}
    SALE_PLAN: '/portal/getSalePlan', // 获取销量计划 {userPin:用户pin}
    RETURN_SUGGEST: '/portal/getReturnSuggest', // 获取滞销处理 {sellerNo:卖家编号}
    IHS_KPI: '/portal/getIhsKPI', // 库存指标 {deptNo:事业部编号 sellerNo:卖家编号}
    SALE_PLAN_FOR_WEEK: '/portal/getSalePlanForWeek', // 当周销售计划完成率 {deptNo:事业部编号}
    PBS_KPI: '/portal/getPbsKPI', // 补货指标 {deptNo:事业部编号}
    // GMV信息
    /* {
     deptNo:事业部编号
     sellerNo:卖家编号
     dateGran:时间维度("week"、"day"、"month")
     } */
    GMV_INFO: '/portal/getGmvInfo'
  },
  INDEX_URLS: {
    LOGGING_VALID: '/auth-rest/loggingValid',
    SELLERNO_USER: '/auth-rest/apply/info/sellerNoUser',
    APPLY_SAVE: '/auth-rest/apply'
  },
  REMIND: {
    SELLER_REMIND: '/auth-rest/remind/seller/getInfo', // 获取初始化信息
    SAVE_REMIND: '/auth-rest/remind/seller/saveInfo', // 保存設置
    MESSAGE_LIST: '/auth-rest/remind/message/messageList',
    READ_ALL_MESSAGE: '/auth-rest/remind/message/readAllMessage',
    READ_MESSAGE: '/auth-rest/remind/message/readMessage',
    UNREAD_COUNT: '/auth-rest/remind/message/unReadCount'
  },
  HOME_NEW: {
    DATE_DT: '/auth-rest/home/dt', // 获取默认时间
    SALES: '/auth-rest/home/sales', // 获取销售概览相关信息
    MAP: '/auth-rest/home/map', // 获取地图区域相关信息
    STOCK: '/auth-rest/home/stock', // 获取库存概览相关信息
    ACROSS: '/auth-rest/home/across', // 获取履约概览相关信息
    DT_LIST: '/app/v1/dept/info/store/dc/list', // 获取仓数据
    CATEGORY_LIST: '/app/v1/newihs/api/getVenderCategory.ajax' // 获取商品分类
  }
}

export default url
